import { render, staticRenderFns } from "./Will.vue?vue&type=template&id=0a902b65"
import script from "./Will.vue?vue&type=script&lang=js"
export * from "./Will.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports